<template>
  <div class="product-section">
    <div class="df vertical df-around">
      <div class="title">{{ query.localDate }} 产能抽查</div>
      <a-space>
        <!-- <select-day
          :defaultVal="query.localDate"
          @userDelectDay="userSelectDay"
        ></select-day> -->
        <a-button @click="handleUpdateAbnormalProblem(null)">新增</a-button>
      </a-space>
    </div>
    <form-vue ref="fqcRef" @updateTable="updateTable" :type="props.type" :produceOrTpc="produceOrTpc"></form-vue>
    <div ref="tableScrollRef">
      <div class="df both-side" style="margin-top: 20px">
        <div style="margin: 0 auto; width: calc(100vw - 160px)">
          <a-table :columns="productColumns" :loading="tableLoading" :data-source="tableData" :pagination="false"
            :rowClassName="(record, index) => (index % 1 === 0 ? 'table-striped' : null)
              " rowKey="id" bordered :scroll="{ x: 'calc(100vw - 160px)' }">
            <template #action="{ record }">
              <a-space>
                <a-button @click="handleEdit(record)" size="small">编辑</a-button>

                <a-button v-if="props.deleteAuthority" @click="handleDelete(record)" size="small"
                  type="danger">删除</a-button>
              </a-space>
            </template>

            <template #isEducation="{ record }">
              {{ record.isEducation ? "是" : "否" }}
            </template>
            <template #isTrain="{ record }">
              {{ record.isTrain ? "是" : "否" }}
            </template>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, reactive, ref, watch, inject } from "vue";
import {
  getCapacitySpotCheckList,
  deleteCapacitySpotCheck,
} from "@/request/view/product";
import searchVue from "@/views/productDaily/components/quality/PQC/threePieced/search.vue";
import formVue from "@/views/productDaily/components/product/components/updateCapacitySpotCheck/form.vue";
import SelectDay from "@/views/repairprogress/compoments/selectDay.vue";
import { useStore } from "vuex";
import { showModal } from "@/views/repairprogress/serve/modal";
import { Toast, debounce, timeStampToTime } from "@/utils";

export default defineComponent({
  props: {
    deleteAuthority: Boolean,
    type: String,
    produceOrTpc: String,
  },
  components: {
    searchVue,
    formVue,
    SelectDay,
  },
  setup(props, context) {
    const query = reactive({
      localDate: timeStampToTime("", "upload"),
      type: props.type,
      produceOrTpc: props.produceOrTpc
    });
    const store = useStore();

    const userId = computed(() => store.state.user.user.id);

    const productColumns = [
      {
        title: "序号",
        dataIndex: "id",
        width: 80,
        align: "center",
      },
      {
        title: "抽查内容",
        dataIndex: "spotCheckContent",
        width: 165,
        align: "center",
      },
      {
        title: "抽查组员",
        dataIndex: "spotCheckPerson",
        width: 165,
        align: "center",
      },
      {
        title: "抽查情况",
        align: "center",
        children: [
          {
            title: "计划数量",
            dataIndex: "plannedNumber",
            width: 165,
            align: "center",
          },
          {
            title: "完成数量",
            dataIndex: "currentCompletedNumber",
            width: 165,
            align: "center",
          },
          {
            title: "进度评估",
            dataIndex: "progressEvaluation",
            width: 165,
            align: "center",
          },
        ],
      },
      {
        title: "原因",
        dataIndex: "reason",
        width: 165,
        align: "center",
      },
      {
        title: "批评教育",
        // dataIndex: "isEducation",
        slots: {
          customRender: "isEducation",
        },
        width: 165,
        align: "center",
      },
      {
        title: "员工态度",
        dataIndex: "employeeAttitude",
        width: 165,
        align: "center",
      },
      {
        title: "培训",
        // dataIndex: "isTrain",
        slots: {
          customRender: "isTrain",
        },
        width: 165,
        align: "center",
      },
      {
        title: "首样确认",
        dataIndex: "firstConfirm",
        width: 165,
        align: "center",
      },
      {
        title: "操作",
        slots: {
          customRender: "action",
        },
        width: 160,
        align: "center",
        fixed: "right",
      },
    ];

    const tableLoading = ref(false);

    const searchRef = ref();

    const fqcRef = ref();

    const tableScrollRef = ref();

    const tableData = reactive([]);

    const tableScrollWidth = ref(window.screen.width - 80);

    const getTableData = () => {
      tableLoading.value = true;
      getCapacitySpotCheckList(query)
        .then((res) => {
          tableLoading.value = false;
          tableData.length = 0;
          if (
            res.code === 200 &&
            res.message === "成功" &&
            res.data &&
            res.data[props.type]
          ) {
            tableData.push(...res.data[props.type]);
          }
        })
        .catch((err) => {
          tableLoading.value = false;
          console.log(err, "报错");
        });
    };

    const handleDelete = (record) => {
      showModal({
        title: "提示",
        toastText: "确认删除？",
        success: () => {
          deleteCapacitySpotCheck([record.id])
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              if (res.code === 200) {
                getTableData();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const handleEdit = (data) => {
      fqcRef.value.openModal("editUpdateCapacitySpotCheck", data);
    };

    const handleUpdateAbnormalProblem = () => {
      fqcRef.value.openModal("addeditUpdateCapacitySpotCheck");
    };

    const userSelectDay = (time) => {
      if (time) {
        query.localDate = time;
        getTableData();
      }
    };

    const updateTable = () => {
      getTableData();
    };

    const tabActivekey = inject("tabActivekey", null);
    watch(
      () => tabActivekey,
      (val) => {
        console.log(val.value, props.type);
        if (val.value === props.type) {
          getTableData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    const cascadeDate = inject("cascadeDate", null);
    watch(
      () => cascadeDate,
      (val) => {
        if (!val.value) return;
        const date = val.value.format("YYYY-MM-DD");
        if (date !== query.localDate) {
          query.localDate = date;
          getTableData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      userId,
      query,
      handleDelete,
      productColumns,
      searchRef,
      fqcRef,
      tableData,
      tableLoading,
      tableScrollRef,
      userSelectDay,
      handleUpdateAbnormalProblem,
      updateTable,
      handleEdit,
      tableScrollWidth,
    };
  },
});
</script>

<style lang="less" scoped></style>
